import { useEffect } from "react";

function restoreScroll() {
	document.body.style.overflow = "";
	document.documentElement.style.overflow = "";
	const scrollContainer = document.querySelector("[data-discover-scroll]");
	if (scrollContainer instanceof HTMLElement) {
		scrollContainer.style.overflowY = "auto";
		scrollContainer.style.overflowX = "hidden";
	}
	const videoContainers = document.querySelectorAll(".videoPlayer-container, .clipPlayer-container, .gameVideo-container");
	for (const el of videoContainers) {
		if (el instanceof HTMLElement) {
			el.style.maxWidth = "100%";
			el.style.minWidth = "0";
		}
	}
}

export function useRestoreScrollOnFullscreenExit(fullscreen: boolean | undefined) {
	useEffect(() => {
		if (fullscreen === false) restoreScroll();
	}, [fullscreen]);

	useEffect(() => {
		const handler = () => {
			if (!document.fullscreenElement) restoreScroll();
		};
		document.addEventListener("fullscreenchange", handler);
		return () => document.removeEventListener("fullscreenchange", handler);
	}, []);
}
